// extracted by mini-css-extract-plugin
export default {"mischka":"#d0d5dd","avatar":"styles_avatar__2BLDx","image":"styles_image__6XtcZ"};